import type { ColumnDef, Table } from "@tanstack/react-table";

import type { IToeLinesData } from "../types";
import type { LinesSort } from "gql/graphql";
import { useTable } from "hooks/use-table";
import type { TStore } from "utils/zustand";

interface ISortByHelper {
  sortBy?: { field: string; order: "ASC" | "DESC" }[];
}

interface IUseToeLinesTableProps {
  tableColumns: ColumnDef<IToeLinesData>[];
  toeLines: IToeLinesData[];
  handleNextPage: () => Promise<void>;
  tableHelpers: ISortByHelper;
  isInternal: boolean;
  canUpdateAttackedLines: boolean;
  handleSearch: (search: string) => void;
  size?: number;
  loading: boolean;
}

export function useToeLinesTable({
  tableColumns,
  toeLines,
  handleNextPage,
  tableHelpers,
  isInternal,
  canUpdateAttackedLines,
  handleSearch,
  size,
  loading,
}: IUseToeLinesTableProps): {
  table: Table<IToeLinesData>;
} {
  return useTable({
    columns: tableColumns,
    data: toeLines,
    fetchMore: handleNextPage,
    filters: tableHelpers as unknown as TStore<IToeLinesData, LinesSort>,
    id: "toe-lines-table",
    options: {
      actionsOptions: { onSearch: handleSearch },
      columnOptions: {
        hidden: [
          "attack_by",
          "be_present",
          "bePresentUntil",
          "daysToAttack",
          "filename",
          "first_attack_at",
          "last_author",
          "seen_at",
          "sortsSuggestions",
          "languageSupport",
          "needsReview",
        ],
        order: [
          "root",
          "loc",
          "status",
          "modified_date",
          "lastCommit",
          "languageSupport",
          "needsReview",
          "sorts_priority_factor",
        ],
        pinned: ["root"],
      },
      filtersMode: "server-side",
      loading,
      paginationMode: "server-side",
      rowOptions: {
        enableMultiSelection: isInternal && canUpdateAttackedLines,
      },
    },
    total: size ?? 0,
  });
}
